'use strict';

var cov_gpndzbzcl = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/app/counting/counting.js',
      hash = 'e576f3e00b9054727d4326b04ea9551abf7722b5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/app/counting/counting.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 43,
          column: 5
        }
      },
      '1': {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 6,
          column: 23
        }
      },
      '2': {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 19
        }
      },
      '3': {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 17,
          column: 8
        }
      },
      '4': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 22,
          column: 8
        }
      },
      '5': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 42
        }
      },
      '6': {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 20
        }
      },
      '7': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 31,
          column: 8
        }
      },
      '8': {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 28,
          column: 11
        }
      },
      '9': {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 26
        }
      },
      '10': {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 27,
          column: 22
        }
      },
      '11': {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 20
        }
      },
      '12': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 40,
          column: 11
        }
      },
      '13': {
        start: {
          line: 35,
          column: 10
        },
        end: {
          line: 37,
          column: 11
        }
      },
      '14': {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 42
        }
      },
      '15': {
        start: {
          line: 39,
          column: 10
        },
        end: {
          line: 39,
          column: 47
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 19,
            column: 26
          },
          end: {
            line: 19,
            column: 27
          }
        },
        loc: {
          start: {
            line: 19,
            column: 45
          },
          end: {
            line: 22,
            column: 7
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 24,
            column: 19
          },
          end: {
            line: 24,
            column: 20
          }
        },
        loc: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 31,
            column: 7
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 25,
            column: 36
          },
          end: {
            line: 25,
            column: 37
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 28,
            column: 9
          }
        }
      },
      '3': {
        name: 'updateSum',
        decl: {
          start: {
            line: 33,
            column: 15
          },
          end: {
            line: 33,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 27
          },
          end: {
            line: 41,
            column: 7
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 34,
            column: 37
          },
          end: {
            line: 34,
            column: 38
          }
        },
        loc: {
          start: {
            line: 34,
            column: 47
          },
          end: {
            line: 40,
            column: 9
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        }, {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 36,
            column: 17
          },
          end: {
            line: 36,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 36,
            column: 17
          },
          end: {
            line: 36,
            column: 25
          }
        }, {
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 30
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 39,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 39,
            column: 30
          }
        }, {
          start: {
            line: 39,
            column: 34
          },
          end: {
            line: 39,
            column: 35
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_gpndzbzcl.s[0];
angular.module('app').component('counting', {
  templateUrl: 'app/counting/counting.html',
  controller: function controller() {
    var ctrl = (++cov_gpndzbzcl.s[1], this);

    ++cov_gpndzbzcl.s[2];
    ctrl.sum = 0;

    ++cov_gpndzbzcl.s[3];
    ctrl.bills = [{ value: 100, color: '#cdeaf0' }, { value: 50, color: '#f8e8c7' }, { value: 20, color: '#f9efcc' }, { value: 10, color: '#f2d0c7' }, { value: 5, color: '#f1ecf3' }, { value: 2, color: '#d9ecfa' }];

    ++cov_gpndzbzcl.s[4];
    ctrl.updateAmount = function (index, amount) {
      ++cov_gpndzbzcl.f[0];
      ++cov_gpndzbzcl.s[5];

      ctrl.bills[index].amount = amount;
      ++cov_gpndzbzcl.s[6];
      updateSum();
    };

    ++cov_gpndzbzcl.s[7];
    ctrl.reset = function () {
      ++cov_gpndzbzcl.f[1];
      ++cov_gpndzbzcl.s[8];

      ctrl.bills = ctrl.bills.map(function (item) {
        ++cov_gpndzbzcl.f[2];
        ++cov_gpndzbzcl.s[9];

        item.amount = 0;
        ++cov_gpndzbzcl.s[10];
        return item;
      });

      ++cov_gpndzbzcl.s[11];
      updateSum();
    };

    function updateSum() {
      ++cov_gpndzbzcl.f[3];
      ++cov_gpndzbzcl.s[12];

      ctrl.sum = ctrl.bills.reduce(function (a, b) {
        ++cov_gpndzbzcl.f[4];
        ++cov_gpndzbzcl.s[13];

        if (angular.isObject(a)) {
          ++cov_gpndzbzcl.b[0][0];
          ++cov_gpndzbzcl.s[14];

          a = ((++cov_gpndzbzcl.b[1][0], a.amount) || (++cov_gpndzbzcl.b[1][1], 0)) * a.value;
        } else {
          ++cov_gpndzbzcl.b[0][1];
        }

        ++cov_gpndzbzcl.s[15];
        return a + ((++cov_gpndzbzcl.b[2][0], b.amount) || (++cov_gpndzbzcl.b[2][1], 0)) * b.value;
      });
    }
  }
});